// The default "start" page for every user, logged in or not.

import React from 'react';
import { connect } from 'react-redux'
import * as $ from 'jquery'

import sized from 'components/Mixins/sized';
import { View as ViewActions } from 'actions';
import SubnavWrapper from 'components/Elements/SubnavWrapper';

class App extends React.Component {
  containerClass() {
    // Boostrap container class wrapping the whole app
    return (this.props.isFullscreen || this.props.kiosk) ? 'container-fluid' : 'container'
  }

  subnav() {
    if (this.props.subnav) {
      return (
        <SubnavWrapper>
          { this.props.subnav }
        </SubnavWrapper>
      )
    }
    return ''
  }

  handleFullscreenChange() {
    const { isFullscreen } = this.props

    if (isFullscreen) {
      $('#main').width('100%').height('100%');
      $('#main').css('padding', '20px 20px 20px 20px').css('margin', '0px');
      $('#subnav-block').hide();
      $('#adafruit-header, #adafruit-footer').hide();

      this._layout_height_timeout = setTimeout(function() {
        $(".grid-layout").css('height', $(window).height() - 50);
      }, 600);

    } else {
      $('#main').removeAttr('style');
      $('#subnav-block').show();
      $('#adafruit-header, #adafruit-footer').show();

      if (this._layout_height_timeout) clearTimeout(this._layout_height_timeout);
    }

  }

  componentDidMount() {
    // Since this is the highest level Component, put document listeners here.
    $(document).on('fullscreenchange', () => {
      if ( document.fullscreenEnabled && document.fullscreenElement ) {
        this.props.fullscreenOn()
      } else {
        this.props.fullscreenOff()
      }
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.isFullscreen !== prevProps.isFullscreen) {
      this.handleFullscreenChange()
    }
  }

  render() {
    const { client, main, heading } = this.props

    const clientReady = !!client

    // If we're in a descendent route, children will be defined.
    //
    // Don't render anything until client is ready.
    return (
      <div id="fullscreen">
        <div id="main" role="main">
          <div id="content-container" className={this.containerClass()}>
            {heading}


            <div className="row">
              {this.subnav()}
              {clientReady ? main : 'Loading client...'}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isFullscreen: state.view.fullscreen,
    kiosk: state.browsing.kiosk,
    loading: state.session.loading,
    client: state.session.client,
    user: state.session.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fullscreenOn: () => dispatch(ViewActions.setFullscreenOn()),
    fullscreenOff: () => dispatch(ViewActions.setFullscreenOff()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(sized(App));
